import React from 'react';
import { getLoginUrl } from '../utils/config';
import { AnimatedBackground } from './AnimatedBackground';
import './Hero.css';

export const Hero: React.FC = () => {
  const handleComecarAgora = () => {
    window.location.href = getLoginUrl();
  };

  return (
    <section className="hero-section">
      <AnimatedBackground />
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-headline">
            Clareza para decisões de engenharia, performance e confiabilidade
          </h1>
          <p className="hero-subheadline">
            Entenda o desempenho do seu time, monitore a performance dos contribuidores com Opindex e gerencie incidentes para melhorar a confiabilidade dos seus sistemas.
          </p>
          <div className="hero-ctas">
            <button className="btn-hero-primary" onClick={handleComecarAgora}>
              Começar Agora
            </button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-dashboard-preview">
            <div className="dashboard-mock">
              <div className="mock-header">
                <div className="mock-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="mock-content">
                <div className="mock-metrics">
                  <div className="mock-metric">
                    <div className="mock-metric-label">Cycle Time</div>
                    <div className="mock-metric-value">2.3h</div>
                    <div className="mock-metric-tag">Engenharia</div>
                  </div>
                  <div className="mock-metric">
                    <div className="mock-metric-label">Opindex</div>
                    <div className="mock-metric-value">85.3</div>
                    <div className="mock-metric-tag">Performance</div>
                  </div>
                  <div className="mock-metric">
                    <div className="mock-metric-label">MTTR</div>
                    <div className="mock-metric-value">4.2h</div>
                    <div className="mock-metric-tag">Confiabilidade</div>
                  </div>
                  <div className="mock-metric">
                    <div className="mock-metric-label">Deploy Rate</div>
                    <div className="mock-metric-value">98%</div>
                    <div className="mock-metric-tag">Engenharia</div>
                  </div>
                </div>
                <div className="mock-chart-large">
                  <div className="mock-chart-bars">
                    {[60, 75, 50, 85, 65, 90, 70, 80].map((height, i) => (
                      <div key={i} className="mock-bar" style={{ height: `${height}%` }}></div>
                    ))}
                  </div>
                </div>
                <div className="mock-chart-small">
                  <div className="mock-line-chart">
                    <svg viewBox="0 0 200 80" className="mock-svg">
                      <polyline
                        points="0,70 25,60 50,50 75,45 100,40 125,35 150,30 175,25 200,20"
                        fill="none"
                        stroke="var(--primary)"
                        strokeWidth="2"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

